import React, { useState, useRef, useEffect } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { showToast } from "../../utils/hot-toast";

const PresalesTools = ({
    tokenDetails,
    showDetailModal,
    setWhitelistModalVisible,
    presaleContract,
    account,
    lockerLPContract,
}) => {
    const [promoModalVisible, setPromoModalVisible] = useState(false);
    const [checked, setChecked] = useState(tokenDetails.isWhitelist);
    const promoRef = useRef(null);

    const [lockedTimestamp, setLockedTimeStamp] = useState(0);

    useEffect(() => {
        if (lockerLPContract) {
            const loadLockedTimeStamp = async () => {
                const _lockedTimeStamp = await lockerLPContract.methods
                    .LockedTimestamp()
                    .call();
                setLockedTimeStamp(_lockedTimeStamp);
            };
            loadLockedTimeStamp();
        }
    }, [lockerLPContract]);

    const toggleWhitelist = async (isWhitelist) => {
        try {
            if (isWhitelist) {
                await presaleContract.methods
                    .activateWhitelist()
                    .send({ from: account });
            } else {
                await presaleContract.methods
                    .disableWhitelist()
                    .send({ from: account });
            }
            setChecked(isWhitelist);
            showToast("SUCCESS", "Successfully updated!");
        } catch (error) {
            showToast("ERROR", "Something went wrong!");
        }
    };
    const cancelPresaleOwner = async () => {
        await presaleContract.methods
            .cancelPresaleOwner()
            .send({ from: account });
    };
    const finalizePresale = () => {
        setPromoModalVisible(true);
    };

    const submitFinalize = async () => {
        if (
            tokenDetails.weiRaised >=
            tokenDetails.hardCap + tokenDetails.minContribution
        ) {
            await presaleContract.methods
                .finalizePresale()
                .send({ from: account });
        } else {
            console.log("finalizePresaleForSoftcap");
            await presaleContract.methods
                .finalizePresaleForSoftcap()
                .send({ from: account });
        }

        showToast("SUCCESS", "Finalised Successfully!");
        setPromoModalVisible(false);
    };

    const addDiscountCode = async () => {
        const code = parseInt(promoRef.current.value);
        if (isNaN(code)) {
            return;
        }
        await presaleContract.methods
            .setDiscountCode(code)
            .send({ from: account });

        showToast("SUCCESS", "Promocode added!");
    };

    const withdrawLiquidity = async () => {
        try {
            await lockerLPContract.methods
                .claimLockedTokens()
                .send({ from: account });
            showToast("SUCCESS", "Successfully withdrew liquidity tokens!");
        } catch (error) {
            showToast("ERROR", "Something went wrong!");
        }
    };

    const burnLeftOverToken = async () => {
        try {
            await lockerLPContract.methods
                .burnLeftOverToken()
                .send({ from: account });
            showToast("SUCCESS", "Successfully burnt left tokens!");
        } catch (error) {
            showToast("ERROR", "Something went wrong!");
        }
    };
    const withdrawTokensFailedPresale = async () => {
        try {
            await presaleContract.methods
                .withdrawTokensFailedPresale()
                .send({ from: account });
            showToast("SUCCESS", "Successfully withdrew failed tokens!");
        } catch (error) {
            showToast("ERROR", "Something went wrong!");
        }
    };

    const PromoCodeModal = () => {
        return (
            <div
                className={`${promoModalVisible ? "flex" : "hidden"} ace-modal`}
            >
                <div
                    className="ace-modal-overlay"
                    onClick={() => setPromoModalVisible(false)}
                />
                <div className="ace-modal-main w-10/12 md:w-96">
                    <div className="ace-modal-header">
                        Got a Promo Code?
                        <button
                            type="button"
                            className="ace-modal-close-button"
                            onClick={() => setPromoModalVisible(false)}
                        >
                            <svg
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div className="ace-modal-body p-4 md:p-6 flex flex-col">
                        <div className="flex flex-col gap-3">
                            <span>Use promo code for 12.5% BNB back!</span>
                            <input
                                placeholder="Enter Promocode"
                                ref={promoRef}
                                className="rounded-full pl-8"
                            />
                            <div className="flex flex-row gap-4 justify-center">
                                <button
                                    className="size-sm lg:size-base bg-itemIndigo dark:bg-itemPurple text-white rounded-full w-32 py-1"
                                    onClick={addDiscountCode}
                                >
                                    Add
                                </button>
                                <button
                                    className="size-sm lg:size-base border-2 border-itemIndigo dark:border-itemPurple text-itemIndigo dark:text-itemPurple rounded-full w-32 py-1"
                                    onClick={submitFinalize}
                                >
                                    Finalise
                                </button>
                            </div>
                            <span>If no promocode you can just finalise</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>You are good to go!</span>;
        } else {
            // Render a countdown
            return (
                <div className="flex gap-1">
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(days)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(hours)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(minutes)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(seconds)}
                    </span>
                </div>
            );
        }
    };

    return (
        <div className="component-container rounded-lg shadow-lg p-6 flex flex-col h-full">
            {PromoCodeModal()}
            <span className="size-2 font-semibold pb-2">Update Details</span>
            <div className="flex flex-row justify-between py-2">
                <span>Update Presale Details</span>
                <button
                    className="blueGradient-button w-24 py-2 size-sm"
                    onClick={() => showDetailModal(true)}
                >
                    Update
                </button>
            </div>
            <div className="flex flex-row justify-between py-2 items-center">
                <span>
                    Presale whitelist:
                    <span
                        className={
                            checked ? "text-kad-gradient" : "text-[#A6B2BC]"
                        }
                    >
                        {checked ? " Enabled" : " Disabled"}
                    </span>
                </span>

                <button
                    onClick={() => toggleWhitelist(!checked)}
                    className={`${
                        checked ? "bg-[#FC5ED033]" : "bg-[#A6B2BC4D]"
                    } switch-group mr-4`}
                >
                    <span
                        className={`${
                            checked
                                ? "translate-x-[20px] bg-kadido-gr"
                                : "translate-x-[0px] bg-[#A6B2BC]"
                        } switch-thumb`}
                    />
                </button>
            </div>
            <div className="flex flex-row justify-between py-2 items-baseline">
                <span>Add/Remove Adresses (Whitelist)</span>

                <button
                    className="blueGradient-button w-24 py-2 size-sm"
                    onClick={() => setWhitelistModalVisible(true)}
                >
                    Update
                </button>
            </div>
            <div className="flex flex-row justify-between py-2 items-center">
                <span>
                    Withdraw Liquidity tokens
                    <br />
                    {lockedTimestamp ? (
                        <span className="size-sm text-right">
                            <Countdown
                                date={new Date(lockedTimestamp * 1000)}
                                renderer={renderer}
                            />
                        </span>
                    ) : (
                        ""
                    )}
                </span>
                <div className="flex justify-end flex-col items-end">
                    <button
                        className="secGr-button w-24 py-2 size-sm"
                        onClick={withdrawLiquidity}
                        disabled={lockedTimestamp === 0}
                    >
                        Withdraw
                    </button>
                </div>
            </div>

            <div className="flex flex-row justify-between py-2 items-center">
                <span>Burn unused tokens</span>
                <div className="flex justify-end flex-col items-end">
                    <button
                        className="secGr-button w-24 py-2 size-sm"
                        onClick={burnLeftOverToken}
                    >
                        Burn
                    </button>
                </div>
            </div>

            <div className="flex flex-row justify-between py-2 items-center">
                <span>Claim Failed tokens</span>
                <div className="flex justify-end flex-col items-end">
                    <button
                        className="secGr-button w-24 py-2 size-sm"
                        onClick={withdrawTokensFailedPresale}
                    >
                        Claim
                    </button>
                </div>
            </div>

            <div className="flex flex-row justify-around pt-2 items-center flex-wrap gap-y-3">
                <button
                    className="thiGr-button w-40"
                    onClick={cancelPresaleOwner}
                >
                    Cancel
                </button>
                <button
                    className="blueGradient-button w-40"
                    onClick={finalizePresale}
                >
                    Finalise
                </button>
            </div>
        </div>
    );
};
export default PresalesTools;
